// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__237M7","mainLink":"Home_mainLink__1xH6M"};